import React from 'react';
import { useTranslation } from 'react-i18next';
import MenuPaintedButton from '../components/MenuPaintedButton';
import {
  AFTER_BATTLE_GREEN_BUTTON_PATH,
  AFTER_BATTLE_WHITE_BUTTON_PATH,
} from '../config/welcomeAssets';
import './RematchRequestDialog.css';

export default function RematchRequestDialog({ offer, onAccept, onReject }) {
  const { t } = useTranslation();
  if (!offer) {
    return null;
  }
  const kindLabel =
    offer.kind === 'mirror'
      ? t('rematch.mirrorRematch')
      : t('rematch.rematch');
  return (
    <div className="rematch-request-overlay" role="alertdialog" aria-modal="true">
      <div className="rematch-request-dialog">
        <h2 className="rematch-request-title">{t('rematch.offerTitle', { kind: kindLabel })}</h2>
        <p className="rematch-request-body">
          {t('rematch.offerBody', {
            username: offer.fromUsername,
            kind: kindLabel,
          })}
        </p>
        <div className="rematch-request-actions">
          <MenuPaintedButton
            imagePath={AFTER_BATTLE_GREEN_BUTTON_PATH}
            className="rematch-request-btn"
            onClick={onAccept}
          >
            {t('rematch.accept')}
          </MenuPaintedButton>
          <MenuPaintedButton
            imagePath={AFTER_BATTLE_WHITE_BUTTON_PATH}
            className="rematch-request-btn"
            onClick={onReject}
          >
            {t('rematch.reject')}
          </MenuPaintedButton>
        </div>
      </div>
    </div>
  );
}
